import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=9edd6e5c&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=9edd6e5c&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9edd6e5c",
  null
  
)

export default component.exports